<template>

	<ul class="learning_report_list">
		<!-- 교육과정 게시판은 게시글 4개 -->
		<li :id="'item-' + item.emIdx" v-for="(item, index) in eduList">
			<a href="javascript:;" @click="goLearn(item)">
				<figure class="list_thumb">
					<img v-if="item.thumbnail != null && item.thumbnail !== ''" :src="item.thumbnail" alt="">
					<img v-else src="/ssflex/assets/img/common/img_thumb.svg" alt="">
				</figure>
				<div class="list_text">
					<em class="cate">
						<span class="notice_cate" v-if="item.isMajor">주요교육</span>
						<span v-if="item.cateCode != null">{{ item.cateCodeVO.codeName }}</span>
					</em>
					<strong class="tit">{{ item.shortTitle }} {{ item.eduTitle }}</strong>
					<div class="progress_wrap">
						<div class="progress">
							<div class="progress_text">
								<span>학습진행률</span>
								<span class="per">{{  item.completeContentCnt | avg( item.allContentCnt )  }}%</span>
							</div>
							<div class="progress_bar">
								<span :style="'width:' + ( $options.filters.avg( item.completeContentCnt, item.allContentCnt )) + '%;'"></span>
							</div>
						</div>
						<div class="info">

							<dl v-for="( content, i ) in item.contentList">

								<template v-if="content.contentType === 'mov'">
									<dt>{{content.qstMovVO.movTitle}}</dt>
									<dd>
										<template v-if="item.studentVO.answerList[i] != null && item.studentVO.answerList[i].ansMovVO != null">
											{{ Math.floor(item.studentVO.answerList[i].ansMovVO.currentTimes / 60) }}분
										</template>
										<template v-else>
											0분
										</template>
										/ {{content.qstMovVO.playMinutes}}분
									</dd>
								</template>

								<template  v-else-if="content.contentType === 'file'" >
									<dt>{{ content.qstFileVO.fileDesc }}</dt>
									<dd>
										<template v-if="item.studentVO.answerList[i] != null">
											{{ item.studentVO.answerList[i].fileDownloadCount }}
										</template>
										<template v-else>
											0
										</template>
										/ {{content.qstFileVO.fileList.length}}개
									</dd>
								</template>

								<template  v-else-if="content.contentType === 'tst'">
									<dt>테스트</dt>
									<dd>
										<template v-if="item.studentVO.answerList[i] != null">
											{{ item.studentVO.answerList[i].tstSolveCount }}
										</template>
										<template v-else>
											0
										</template>
										/ {{content.qstTstList.length}}문항
									</dd>
								</template>
							</dl>

						</div>
					</div>
				</div>
			</a>
		</li>
	</ul>

</template>

<script>
export default {
	name: "eduMineList",
	props: {
		forApp: {
			type: Boolean,
			default: false,
		},
		eduList: Array,
	},
	data() {

		return {
			//eduList: [],
			eduCount: 0,
		}
	},
	created() {

	},
	mounted() {

	},
	methods: {


		goLearn( _item ) {
			if ( this.forApp ) {
				this.goAppEducation(_item.cateCode, _item.emIdx)
			}
			this.$eventBus.$emit("goLearning", _item.emIdx)
		},

	},
}
</script>

<style scoped>

</style>